import React from 'react';

const SoldCourses = () => {
    return (
        <div>

        </div>
    );
};

export default SoldCourses;